export default [
    {
        name: 'React Native',
        width: '100%',
    },
    {
        name: 'ReactJS',
        width: '100%',
    },
    {
        name: 'Javascript',
        width: '100%'
    },
    {
        name: 'TypeScript',
        width: '100%',
    },
    {
        name: 'Node.js',
        width: '95%'
    },
    {
        name: 'Web3',
        width: '90%'
    },
]
